<script setup>
/**
 * TiptapToolbarBtn
 * Reusable, stateless action button designed for a rich-text editor (Tiptap) toolbar.
 * Handles active text-formatting states, styling variations for system theme modes,
 * and executes structural editor commands passed down from a parent controller.
 */
import {computed} from "vue"
import {useUserStore} from '@/stores/user'

const props = defineProps({
    iconClass: {
        type: String,
        required: false,
    },
    isActive: {
        type: Boolean,
        default: false,
    },
    command: {
        type: Function,
        required: true,
    },
    title: {
        type: String,
        default: null,
    },
    isDisabled: {
        type: Boolean,
        default: false,
    }
})

// Pinia Store
const userStore = useUserStore()

// --- Computed ---

const isDarkMode = computed(() => userStore.pref('darkMode'))

// --- Methods ---

const onClick = () => {
    props.command()
}
</script>

<template>
    <button
        type="button"
        class="btn rounded"
        :class="{ 'active': isActive, 'btn-light': !isDarkMode }"
        @click="onClick"
        :title="title"
        :disabled="isDisabled"
    >
        <slot>
            <i :class="[iconClass, { 'text-dark': !isActive && !isDisabled && !isDarkMode, 'text-warning': isDisabled }]"></i>
        </slot>
    </button>
</template>

<style scoped>
.active {
    background-color: #ffc107;
    color: black !important;
}

[data-bs-theme="dark"] .btn:disabled {
    border-color: transparent !important;
}
</style>